<template lang="pug">
  app-toolbar(:title="'Реестр дел'")
    //- History
    template(slot="action")
      v-menu(v-if="hasHistory" open-on-hover offset-y nudge-bottom="10" close-delay="300" allow-overflow)
        template(v-slot:activator="{ on }")
          span.mr-2.pr-2.history-action(v-on="on")
            v-icon history
            v-icon(small) arrow_drop_down
        slot(name="menu")
          v-list.pa-0.sud-toolbar-menu__list(dense)
            v-list-item.sud-toolbar-menu__item(v-for="(item, index) in history" :key="index" tag="div" inactive @click="handleSelectedCase(item)")
              span {{ item.number }}
    //- Items
    app-toolbar-item(v-if="!isLimitView" label="Показать" :items="preparedStatuses" key-name="title" min-width="120" @select="filterByStatus") {{ currentStatus }}
      template(slot="list-item" slot-scope="{ item, index }" ) 
        span.sud-case-status-color(v-bind:style="{ background: statusColor(item) }")
        span.ml-4.text-lowercase {{ item.title }}
    app-toolbar-item-period.ml-6(@select="setPeriod") {{ period ? period.text : 'все' }} 
    app-toolbar-item.ml-6(label="Сортировать" :items="sorterItems" key-name="title" min-width="120" @select="sortBy") {{ currentSort }}
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import { $_app_moment } from "@/common/AppMoment.js"
import colors from "@/assets/data/CaseStatusColors.json"

import moment from 'moment'
moment.locale('ru')

export default {
  mixins: [ $_app_moment ],

  props: {
    isLimitView: Boolean
  },

  computed: {
    ...mapState('list', ['selectedStatus', 'selectedSort', 'period', 'typePeriod']),
    ...mapGetters('list', ['statuses']),
    ...mapGetters('list', ['history']),

    hasHistory () {
      return this.history && this.history.length > 0
    },

    sorterItems () {
      return ['по дате', 'по нумерации', 'по категориям'].map(el => ({ title: el }))
    },

    currentSort () {
      return this.sorterItems[this.selectedSort].title
    },

    currentStatus () {
      return this.selectedStatus ? this.selectedStatus.title : 'Все'
    },

    preparedStatuses () {
      let lastColor = 0
      let list = [{ title: 'Все', color: -1 }]

      this.statuses.filter(item => item.name!="Delete").forEach(element => {
        if (lastColor != element.color) list.push({ divider: true })
        lastColor = element.color
        list.push(element)
      })

      return list
    }
  },

  methods: {
    ...mapMutations('list', ['selectStatus', 'selectSort', 'setPeriod']),

    handleSelectedCase (selectedCase) {
      this.$router.push({ path: `/case/${selectedCase.id}` })
    },

    handlePeriod (item) {
      item.action()
    },

    showDayDialog () {
      this.dialogDay = true
    },
    
    showMonthDialog () {
      this.dialogMonth = true
    },

    statusColor(item) {
      return (item.color in colors) ? colors[item.color] : ''
    },

    filterByStatus(item) {
      this.selectStatus(item.color != -1 ? item : null)
      if (item.value == 9) this.$store.dispatch('list/LOAD_CASE_BY_STATUS_OFFICE', item.name)
      if (item.value == 10) this.$store.dispatch('list/LOAD_CASE_BY_STATUS_ARCHIVE', item.name)
    },

    sortBy(item, index) {
      this.selectSort(index)
    }
  }
}
</script>

<style lang="scss" scoped>
.history-action {
  border-right: 1px solid #C4C4C4;
}
</style>